import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutsModule } from './shared/components/layouts/layouts.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { httpInterceptorProviders } from './services/index';
import { HttpClientModule } from '@angular/common/http';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { library } from '@fortawesome/fontawesome-svg-core';
import { ToastrModule } from 'ngx-toastr';
import { DceSharedModule } from './dce-shared/dce-shared.module';
import { Resolver } from './resolver';
@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    LayoutsModule,
    FontAwesomeModule,
    HttpClientModule,
    BrowserAnimationsModule,
    DceSharedModule,
    ToastrModule.forRoot()
  ],
  providers: [
    Resolver,
    httpInterceptorProviders,
    // Title
  ],
  bootstrap: [AppComponent]
})
export class AppModule { 
  constructor() {
    library.add(fas);
    library.add(far);
  }
}
